export default { sha: '9ddae7ea963707cce592e2aa67731e4a045db468', buildNumber: 'undefined' }
